import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useState, useEffect } from 'react';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import { useProduct } from '../../../ProductProvider';
import { IPageStatus } from '../../../config/IPageStatus';
import { getIsLogin } from '@/utils/cookie';
import { useRouter } from 'next/router';
import gtm from '@/utils/gtm';

export default function ModalItems({ callback, data, index, setActivetedTabs }: any) {
    const { t } = useLang('dpux');
    const { locale = '' } = useRouter();
    const [visible, setVisible] = useState(false);
    const { title, lists, tip, btn } = data;
    const { state, dispatch } = useProduct();
    const pageStatus = state.pageStatus;
    const [login, setLogin] = useState(false);
    const [location, setLocation] = useState<any>(null);

    const handleClose = () => {
        setVisible(false);
        setTimeout(() => {
            callback();
        }, 0);
    };

    const handleToBundle = (btnName: string) => {
        callback();
        setActivetedTabs((activetedTabs: any) => {
            if (activetedTabs.includes('Bundle')) {
                return activetedTabs;
            } else {
                return [...activetedTabs, 'Bundle'];
            }
        });

        setActivetedTabs;
        gtm.push({
            event: 'uaEvent',
            event_name: btnName,
            product_name: title,
            position: `Product Detail_4_Modal_${index}`,
        });
        dispatch({
            type: 'changeProductTab',
            payload: 'Bundle',
        });
        setTimeout(() => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        }, 0);
    };

    useEffect(() => {
        setLogin(getIsLogin());
        setTimeout(() => {
            setVisible(true);
        }, 200);
        if (typeof window !== 'undefined') {
            setLocation(window.location);
        }
    }, []);

    return (
        <div
            className={`dpux-modal-terms ${css.modal} GtmModuleData-section ${visible ? 'visible' : ''}`}
            data-section-id={css.modal}
            data-section-title={title}
        >
            <div className={`content ${visible ? 'visible' : ''}`}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20" fill="none" onClick={handleClose}>
                    <circle cx="10" cy="10" r="10" fill="white" fillOpacity="0.4" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.76758 9.82812L6.46918 12.1265C6.17629 12.4194 6.17629 12.8943 6.46918 13.1872C6.76207 13.4801 7.23695 13.4801 7.52984 13.1872L9.82824 10.8888L12.1266 13.1872C12.4195 13.4801 12.8944 13.4801 13.1873 13.1872C13.4802 12.8943 13.4802 12.4194 13.1873 12.1265L10.8889 9.82812L13.1867 7.53033C13.4796 7.23744 13.4796 6.76256 13.1867 6.46967C12.8938 6.17678 12.4189 6.17678 12.126 6.46967L9.82824 8.76746L7.53045 6.46967C7.23755 6.17678 6.76268 6.17678 6.46979 6.46967C6.17689 6.76256 6.17689 7.23744 6.46979 7.53033L8.76758 9.82812Z"
                        fill="white"
                    />
                </svg>
                <p className="modal-title">{title}</p>
                <ul className="modal-lists">
                    {lists.map((item: { name?: string; text: string; img: string }, k: number) => (
                        <li key={k} className={`modal-list modal-${index + 1}`}>
                            <div className="modal-list-img">
                                <EcoImg pc={item?.img} />
                            </div>
                            <div className="modal-list-info">
                                {item?.name && <p className="modal-list-name">{item.name}</p>}
                                <p className="modal-list-text">{item.text}</p>
                            </div>
                        </li>
                    ))}
                </ul>
                <p className="modal-tip">{tip}</p>
                {btn?.btnText &&
                    ((btn?.btnLink && pageStatus === IPageStatus.TEASER) ||
                        ([IPageStatus.SUPER_EARLY, IPageStatus.EARLY].includes(pageStatus) && index === 0 && !login)) && (
                        <EcoLink
                            className="modal-btn GtmModuleData-btn-href"
                            href={
                                pageStatus === IPageStatus.TEASER
                                    ? btn?.btnLink
                                    : [IPageStatus.SUPER_EARLY, IPageStatus.EARLY].includes(pageStatus) && index === 0 && !login
                                    ? `${location?.protocol}//${location?.host}/${locale}/login?redirect=${location?.protocol}//${location?.host}${
                                          location?.pathname
                                      }${location?.search ? encodeURI(location?.search) : ''}${location?.search ? '&' : '?'}tab=Bundle`
                                    : '/'
                            }
                            target="_blank"
                            dataLayer={
                                index === 0 && !login
                                    ? {
                                          event: 'uaEvent',
                                          event_name: 'authentication_button',
                                          type: 'Redirect',
                                          button_name: btn?.btnText,
                                          url:
                                              pageStatus === IPageStatus.TEASER
                                                  ? btn?.btnLink
                                                  : `${location?.protocol}//${location?.host}/${locale}/login?redirect=${location?.protocol}//${
                                                        location?.host
                                                    }${location?.pathname}${location?.search ? encodeURI(location?.search) : ''}${
                                                        location?.search ? '&' : '?'
                                                    }tab=Bundle`,
                                          __btn_id1: css.section,
                                          __btn_id2:
                                              pageStatus === IPageStatus.TEASER
                                                  ? btn?.btnLink
                                                  : `${location?.protocol}//${location?.host}/${locale}/login?redirect=${location?.protocol}//${
                                                        location?.host
                                                    }${location?.pathname}${location?.search ? encodeURI(location?.search) : ''}${
                                                        location?.search ? '&' : '?'
                                                    }tab=Bundle`,
                                      }
                                    : {
                                          event: 'uaEvent',
                                          event_name: 'buy_now',
                                          product_name: 'EcoFlow DELTA Pro Ultra X',
                                          position: `Product Detail_4_Modal_${index}`,
                                          __btn_id1: css.section,
                                          __btn_id2: btn?.btnLink,
                                      }
                            }
                        >
                            {btn?.btnText}
                        </EcoLink>
                    )}
                {btn?.btnText && [IPageStatus.SUPER_EARLY, IPageStatus.EARLY].includes(pageStatus) && !(index === 0 && !login) && (
                    <button
                        className="modal-btn GtmModuleData-btn-text"
                        onClick={() => handleToBundle(index === 0 && login ? t(`D_item2_modal_btn_text_super_early`) : btn?.btnText)}
                    >
                        {index === 0 && login ? t(`D_item2_modal_btn_text_super_early`) : btn?.btnText}
                    </button>
                )}
            </div>
        </div>
    );
}
